module.exports = __webpack_public_path__ + "static/media/corner_bg.5bcddae0.svg";